import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import config from '../config'
import i18n from '../i18n'

Vue.use(Vuex);


export default new Vuex.Store({
    state: {
        initialized: false,
        isExetension: location.pathname.indexOf('/extension/') === 0,
        signedIn: false,
        user: {},
        signInToken: '',
        hadSubscription: false,
        videosByLocale: {
            "PlayDestiny2OnStadiaFromUnsupported": {
                en: 'mdqyU2HmVrc',
                ru: 'tC3OhpNQPFQ',
                uk: 'tC3OhpNQPFQ',
                es: 'OsFvBVJUKEo',
                ar: 'CE5SwSTdA2E',
            }
        },
        talkingAboutUsVideos: [
            {
                header: i18n.t('talkingAboutUs.video1_title'),
                imageHeight: '131px',
                imageWidth: '110px',
                videoId: 'iTH4weDQaAs',
                subtitle: '',
                subject: 'Cloud Gaming Xtreme'
            },
            {
                header: i18n.t('talkingAboutUs.video2_title'),
                imageHeight: '131px',
                imageWidth: '110px',
                videoId: 'f9YNMouMwp0',
                subtitle: '',
                subject: 'Hot Cloud Gaming BR'
            },
            {
                header: i18n.t('talkingAboutUs.video3_title'),
                imageHeight: '131px',
                imageWidth: '110px',
                videoId: 'Ynxs4Hj9yME',
                subtitle: '',
                subject: 'Eddie Player 1'
            },
            {
                header: i18n.t('talkingAboutUs.video4_title'),
                imageWidth: '210px',
                imageHeight: '120px',
                videoId: 'kXFUBpUpOHs',
                subtitle: '',
                subject: 'No Play No Game'
            }
        ]
    },
    getters: {
       videos:  state => {

           const videoByLocale = state.videosByLocale.PlayDestiny2OnStadiaFromUnsupported[i18n.locale];

           return {
               PlayDestiny2OnStadiaFromUnsupported: videoByLocale || state.videosByLocale.PlayDestiny2OnStadiaFromUnsupported.en
           }
       },
    },
    mutations: {
        initialized(state) {
            state.initialized = true;
        },
        signIn(state, payload) {

            state.signedIn = true;
            state.signInToken = payload.token;
            state.user = {...payload};
            state.hadSubscription = state.user.hadSubscription;

        },
        setHadSubscription(state, hadSubscription) {
            state.hadSubscription = hadSubscription;
        },
        setHaveSubscription(state, haveSubscription) {
            state.user.haveSubscription = haveSubscription;
        },
        signOut(state) {


            Vue.$UAnalytics.signedOut();
            state.signInToken = '';
            state.signedIn = false;
            state.user = {};

        },
        updateStorage(state, payload) {

            if (state.isExetension) {

                localStorage.extension_User = JSON.stringify(payload);
                localStorage.extension_SignInToken = payload.token;

            } else {

                localStorage.user = JSON.stringify(payload);
                localStorage.signInToken = payload.token;

            }

        },
        clearStorage(state) {

            if (state.isExetension) {

                delete localStorage.extension_User;
                delete localStorage.extension_SignInToken;

            } else {

                delete localStorage.user;
                delete localStorage.signInToken;

            }

        },
        loadStorage(state) {

            if (state.isExetension && localStorage.extension_SignInToken) {

                state.signInToken = localStorage.extension_SignInToken;
                state.user = JSON.parse(localStorage.extension_User);
                state.hadSubscription = state.user.hadSubscription

            } else if (!state.isExetension && localStorage.signInToken) {

                state.signInToken = localStorage.signInToken;
                state.user = JSON.parse(localStorage.user);
                state.hadSubscription = state.user.hadSubscription

            }

            state.signedIn = Boolean(state.signInToken);


        },
    },
    actions: {
        created({state}) {

            this.commit('loadStorage');

            if(state.signedIn){
                this.dispatch('syncUser', state.signInToken);
            }else{

                if(state.isExetension && !state.signedIn && localStorage.signInToken){

                    state.signedIn = true;
                    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! IMPORTANT !!!!! localStorage.extensionSignInToken for backcomp
                    state.signInToken = localStorage.extension_SignInToken = (localStorage.extensionSignInToken || localStorage.signInToken);
                    state.user = localStorage.extension_User = localStorage.user;

                    this.dispatch('syncUser', state.signInToken);

                }else{

                    this.commit('initialized');

                }


            }

            Vue.$Tawk.setAttributes({source: state.isExetension ? 'extension' : 'website'});

            Vue.$Tawk.setNamePrefix(state.isExetension ? '[ext] ' : '[web] ');

            if (state.signedIn) {

               // Vue.$TrackJS.console.debug("it's happening!", {foo: "bar"});

                Vue.$Tawk.setAttributes(state.user);
                Vue.$Tawk.showWidget();

            } else {

                Vue.$Tawk.hideWidget();

            }


        },
        signIn({commit, state}, payload) {

            commit('signIn', payload);
            commit('updateStorage', payload);

            this._vm.$gapi.signOut();

          //  Vue.$TrackJS.addMetadata(state.user);
            Vue.$Tawk.addEvent('user-signed-in');
            Vue.$Tawk.setAttributes(state.user);
            Vue.$Tawk.showWidget();

        },
        async syncUser({commit}, userToken) {

            const response = await fetch(`${config.serverURL}/account/sync`, {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({userToken})
            });

            const payload = await response.json();

            commit('signIn', payload);

            commit('updateStorage', payload);
            commit('initialized');

        },
        async signOut({commit}, options = {}) {

            commit('clearStorage');
            commit('signOut');

            if (options.navigate !== false) {
                setTimeout(() => router.push({path: '/'}), 100);
            }

            await this._vm.$gapi.signOut();

            Vue.$Tawk.addEvent('user-signed-out');
            Vue.$Tawk.endChat();
            Vue.$Tawk.hideWidget();

        },
        setLocale({}, locale){

            Vue.router.push({params: {locale :locale}})
            Vue.vuetify.framework.rtl = ["iw","ar"].indexOf(locale) > -1;
            localStorage.preferedLocale = locale;

        }
    },
    modules: {}
})
